<template>
  <v-dialog v-model="show" max-width="290">
    <v-card max-width="290px">
      <v-row>
        <v-col>
          <v-date-picker
            v-model="picker"
            :locale="language"
            color="orange darken-1"
            header-color="orange darken-1"
            full-width
          ></v-date-picker>
        </v-col>
      </v-row>
      <v-card-actions class="mt-2 pb-3 d-flex justify-end">
        <v-btn x-small plain color="#027223" @click="show = false">
          {{ translations.cancel }}</v-btn
        >
        <v-btn x-small plain color="#027223" @click="emitData">
          {{ translations.accept }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    picker: "",
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("session", ["language"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    emitData() {
      this.show = false;
      this.$emit("picker", this.picker);
    },
  },
};
</script>
